<script lang="ts">
	import { slide } from 'svelte/transition';
    import SvgFile   from '../icon/SvgFile.svelte';

    export let zip_data : string;
    export let zip_name : string;
</script>

<div transition:slide >
    <h3>STEP 5. 合成完了！</h3>
    <p id="download-link">
        <a download={zip_name} href={zip_data}>
            <SvgFile /><br />
            <span>ダウンロード！</span>
        </a>
    </p>
    <h3>STEP 6. ファイルを設置</h3>
    <p>
        ダウンロードしたファイルを解凍しVRoid Studioのフォルダに設置してください。<br />
        あとはVRoid Studioから使うだけ！
    </p>
</div>

<style>
    p#download-link {
        text-align: center;
    }
    p#download-link a {
        cursor: pointer;
    }
</style>